import { Button } from '@/components/ui/button';
import { Download } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { exportToExcel, exportToPDF } from '@/lib/export-utils';

interface ExportButtonsProps {
  data: Record<string, any>[];
  columns: { header: string; key: string }[];
  fileName: string;
  title?: string;
}

export function ExportButtons({ data, columns, fileName, title }: ExportButtonsProps) {
  if (data.length === 0) return null;

  const handleExcel = () => {
    const mapped = data.map(row => {
      const obj: Record<string, any> = {};
      columns.forEach(c => { obj[c.header] = row[c.key] ?? ''; });
      return obj;
    });
    exportToExcel(mapped, fileName);
  };

  const handlePDF = () => {
    exportToPDF(columns, data, fileName, title);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm">
          <Download size={14} className="mr-1" /> Export
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={handleExcel}>Excel (.xlsx)</DropdownMenuItem>
        <DropdownMenuItem onClick={handlePDF}>PDF</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
